module.exports = __webpack_public_path__ + "static/media/PDF_95.c0729537.pdf";